import {
    Toast
} from 'vant';
// import { getJsApiTicket } from "@/api/users";
export const loading = (flag) => {
    if (flag) {
        Toast.loading({
            mask: true,
            message: '加载中...',
            duration:0
        });
    } else {

        Toast.clear();
    }
}
export function isAndroid () {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    if (isAndroid) {
      return true
    } else {
      return false
    }
  }
// 获取富文本图片地址
export function getImgSrc(richtext) {
    if(richtext){
       let imgList = [];
    richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
          imgList.push(capture);
    });
    return imgList; 
    }else{
        return []
    }
    
}
export function setyoumeng(url){
      // 友盟统计添加
      const script = document.createElement("script");
      script.src = url; //该路径为点击统计代码后，页面中第一个 文字统计 script代码
      script.language = "JavaScript";
      document.body.appendChild(script);
      console.log(111)
}